import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FiMenu,
  FiChevronLeft,
  FiChevronRight,
  FiSearch,
  FiUser,
  FiSettings,
  FiLogOut,
} from "react-icons/fi";
import { logoutAdmin } from "../store/slices/authSlice";
import "./Header.css";

const Header = ({ onToggleSidebar, onToggleCollapse, isSidebarCollapsed }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await dispatch(logoutAdmin()).unwrap();
      navigate("/login");
    } catch (error) {
      // Even if logout API fails, navigate to login
      console.error("Logout error:", error);
      navigate("/login");
    }
  };

  return (
    <header className="app-header">
      <div className="app-header__left">
        <button
          type="button"
          className="icon-button only-mobile"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          <FiMenu size={20} />
        </button>
        <button
          type="button"
          className="icon-button only-desktop"
          onClick={onToggleCollapse}
          aria-label={
            isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"
          }
        >
          {isSidebarCollapsed ? (
            <FiChevronRight size={20} />
          ) : (
            <FiChevronLeft size={20} />
          )}
        </button>
        <div className="header-breadcrumb">
          <span>Admin Control Center</span>
          <h1>System Management</h1>
        </div>
      </div>

      <div className="app-header__right">
        <div className="search-field">
          <FiSearch size={18} />
          <input
            type="search"
            placeholder="Search users, courses, batches..."
            aria-label="Search"
          />
        </div>

        <div className="profile-panel" ref={profileMenuRef}>
          <button
            type="button"
            className="profile-chip"
            onClick={() => setShowProfileMenu((prev) => !prev)}
          >
            <div className="profile-chip__avatar">
              <span>
                {user?.firstName?.[0]}
                {user?.lastName?.[0]}
              </span>
            </div>
            <div className="profile-chip__meta">
              <strong>
                {user?.firstName} {user?.lastName}
              </strong>
              <span>
                {user?.role === "superadmin" ? "Super Admin" : "Admin"}
              </span>
            </div>
          </button>
          {showProfileMenu && (
            <div className="profile-flyout">
              <header>
                <div className="profile-chip__avatar large">
                  <span>
                    {user?.firstName?.[0]}
                    {user?.lastName?.[0]}
                  </span>
                </div>
                <div>
                  <h4>
                    {user?.firstName} {user?.lastName}
                  </h4>
                  <p>{user?.email}</p>
                  <span className="badge">
                    {user?.role === "superadmin" ? "Super Admin" : "Admin"}
                  </span>
                </div>
              </header>
              <nav>
                <button
                  type="button"
                  onClick={() => {
                    navigate("/settings");
                    setShowProfileMenu(false);
                  }}
                >
                  <FiSettings size={18} />
                  Settings
                </button>
              </nav>
              <footer>
                <button type="button" onClick={handleLogout}>
                  <FiLogOut size={18} />
                  Sign out
                </button>
              </footer>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
